import {LlmRunId} from "common/flowmaster/types/llm_run";
import {TestResult} from "common/flowmaster/types/test";
import HideableCellValue from "common_components/flowmaster/llm_run/hideable_cell_value";
import {OutputValue} from "common_components/flowmaster/llm_run/output_cell";
import React from "react";
import TestResultComponent from "routes/llm_run/llm_run_detail/components/test_editor/test_results/test_result";

interface OutputTestResultsProps {
  runId: LlmRunId;
  testResults: TestResult[];
}

interface OutputCellProps {
  runId: LlmRunId;
  value: unknown;
  testResults: TestResult[] | null;
  hidden?: boolean;
  maxHeight?: string;
}

function OutputTestResults({runId, testResults}: OutputTestResultsProps) {
  return (
    <div key={`${runId}-test-results`}>
      {testResults.map(result => {
        return <TestResultComponent key={runId + result.id} result={result} />;
      })}
    </div>
  );
}

export default function OutputCell({
  runId,
  value,
  testResults,
  hidden = false,
  maxHeight,
}: OutputCellProps) {
  return (
    <td>
      <div style={{display: "flex"}}>
        {testResults && !hidden && (
          <OutputTestResults runId={runId} testResults={testResults} />
        )}
        <HideableCellValue hide={hidden} maxHeight={maxHeight}>
          <OutputValue value={value} hide={hidden}></OutputValue>
        </HideableCellValue>
      </div>
    </td>
  );
}
